import { makeAutoObservable, runInAction, computed } from "mobx";
import i18n from "i18next";
import MainStore from "MainStore";
import http from "api/https";

class NewStore {
  data = [];
  searchField = "";

  constructor() {
    makeAutoObservable(this);
  }

  get filteredData() {
    if (!this.searchField.trim()) return this.data;
    const q = this.searchField.toLowerCase();
    return this.data.filter((row: any) =>
      [row.bga_application_number, row.applicant_name, row.approval_type,
       row.current_status, row.organization_name]
        .some((v) => v && String(v).toLowerCase().includes(q))
    );
  }

  async loadMyRequests() {
    try {
      MainStore.changeLoader(true);
      const response = await http.get("/ApprovalRequest/GetMyRequests") as any;
      if ((response.status === 201 || response.status === 200) && response?.data !== null) {
        runInAction(() => {
          this.data = response.data;
        });
      } else {
        throw new Error();
      }
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
    } finally {
      MainStore.changeLoader(false);
    }
  }

  clearStore() {
    runInAction(() => {
      this.data = [];
      this.searchField = "";
    });
  }
}

export default new NewStore();
